// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"loader_loaderWrapper__nvDb9","loader":"loader_loader__DQorR","goo":"loader_goo__+KYLG"};